export default "__VITE_ASSET__C5cAxq1C__"